module.exports = __webpack_public_path__ + "static/media/EDM.c6e07fdd.mp3";